import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$1 } from './p-C78HRAnj.js';

const hyperlinkCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.125rem;box-sizing:border-box;cursor:pointer;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host a{align-items:center;color:inherit;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:600;gap:.25rem;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-decoration:underline;text-overflow:ellipsis;white-space:nowrap}:host([type=regular]){color:var(--jw-theme-system-secondary-default-color)}:host([type=regular]:not([disabled]):hover){color:var(--jw-theme-system-secondary-hover-color)}:host([type=regular]:not([disabled]):active){color:var(--jw-theme-system-secondary-active-color)}:host([type=inverted]){color:var(--jw-theme-surface-bold-link-inverted-default-color)}:host([type=inverted]:not([disabled]):hover){color:var(--jw-theme-surface-bold-link-inverted-hover-color)}:host([type=inverted]:not([disabled]):active){color:var(--jw-theme-surface-bold-link-inverted-active-color)}:host(:not([disabled]):focus){outline:var(--jw-theme-effects-focus-default-outline)}:host([disabled]){cursor:not-allowed}";

const WuiHyperlink = /*@__PURE__*/ proxyCustomElement(class WuiHyperlink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Hyperlink type
         */
        this.type = 'regular';
        /**
         * Text of hyperlink
         */
        this.label = 'Link';
    }
    render() {
        const parsedHrefProps = parseHrefProp(this.href, this.disabled);
        const isExternalLink = parsedHrefProps.href &&
            (parsedHrefProps.href.startsWith('http://') || parsedHrefProps.href.startsWith('https://'));
        const trailingIcon = isExternalLink ? 'external-link' : this.trailingIcon;
        return (h(Host, { key: '36fb82fb19d26ac1fe3ab45519433f76814097b3' }, h("a", { key: '243c87d081a257dd3ae8f5600ff1f25bcda3d0f0', ...parsedHrefProps, ...(isExternalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {}) }, this.leadingIcon && h("wui-icon", { key: '2b53a0b54d4e8c3ade869f3aeb7c3d4843980a10', name: this.leadingIcon }), this.label, trailingIcon && h("wui-icon", { key: 'c4b05c5be5b05e32b75f6ffcb6146a304db1a207', name: trailingIcon }))));
    }
    static get style() { return hyperlinkCss; }
}, [257, "wui-hyperlink", {
        "type": [513],
        "label": [1],
        "href": [1],
        "leadingIcon": [1, "leading-icon"],
        "trailingIcon": [1, "trailing-icon"],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-hyperlink", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-hyperlink":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiHyperlink);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiHyperlink as W, defineCustomElement as d };
